import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * AuthCallback — handles the `#session_id=...` fragment returned by Emergent Google Auth.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * We derive redirect_url from window.location.origin dynamically in the Login/Register button.
 */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/connexion", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        // Clear hash from URL, refresh auth state, then land on Mon compte
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        await refresh();
        toast.success("Connecté avec Google");
        navigate("/mon-compte", { replace: true });
      } catch (err) {
        console.error("Google auth callback failed:", err);
        toast.error("Échec de la connexion Google. Réessayez.");
        navigate("/connexion", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-testid="auth-callback">
      <div className="w-12 h-12 rounded-full border-4 border-[#2B8B8E]/20 border-t-[#2B8B8E] animate-spin mb-4"></div>
      <p className="text-sm text-muted-foreground">Connexion en cours…</p>
    </div>
  );
}
